/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { _ as _slicedToArray } from '../_chunks/dep-dcf624da.mjs';
import { defineComponent, toRefs, ref, computed, createVNode, mergeProps } from 'vue';
import { CloseCircleFilledIcon } from 'tdesign-icons-vue-next';
import { Input } from '../input/index.mjs';
import props from './props.mjs';
import useVModel from '../hooks/useVModel.mjs';
import { useFormDisabled } from '../form/hooks.mjs';
import { useGlobalIcon } from '../hooks/useGlobalIcon.mjs';
import { useCommonClassName, usePrefixClass } from '../hooks/useConfig.mjs';
import { useTNodeJSX } from '../hooks/tnode.mjs';
import '../_chunks/dep-556a2f2c.mjs';
import '../input/input.mjs';
import '../_chunks/dep-e68fd68c.mjs';
import '../input/props.mjs';
import '../input/useInput.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../utils/helper.mjs';
import '../_chunks/dep-8e451077.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-a82b01df.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-192e10f1.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-977c5cdd.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-755716aa.mjs';
import '../_chunks/dep-82798823.mjs';
import '../_chunks/dep-52cbb58a.mjs';
import '../_chunks/dep-db11154e.mjs';
import '../form/const.mjs';
import '../hooks/index.mjs';
import '../hooks/icon.mjs';
import '../hooks/slot.mjs';
import '../hooks/useCommonClassName.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/type.mjs';
import '../hooks/useDefaultValue.mjs';
import '../_chunks/dep-baa4f9dc.mjs';
import '../hooks/useDestroyOnClose.mjs';
import '../hooks/useKeepAnimation.mjs';
import '../hooks/useRipple.mjs';
import '../utils/set-style.mjs';
import '../hooks/useVirtualScroll.mjs';
import '../input/useInputEventHandler.mjs';
import '../input/useInputWidth.mjs';
import '../_chunks/dep-40522c7c.mjs';
import '../_chunks/dep-83862ee1.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-2684fd15.mjs';
import '../input/input-group.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../input/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function calcArrayValue(value) {
  if (Array.isArray(value)) {
    return value;
  }

  return [value, value];
}

var _RangeInput = defineComponent({
  name: "TRangeInput",
  props: props,
  setup: function setup(props2, _ref) {
    var slots = _ref.slots,
        expose = _ref.expose;

    var _toRefs = toRefs(props2),
        value = _toRefs.value,
        modelValue = _toRefs.modelValue;

    var _useCommonClassName = useCommonClassName(),
        STATUS = _useCommonClassName.STATUS,
        SIZE = _useCommonClassName.SIZE;

    var classPrefix = usePrefixClass();
    var disabled = useFormDisabled();
    var COMPONENT_NAME = usePrefixClass("range-input");

    var _useGlobalIcon = useGlobalIcon({
      CloseCircleFilledIcon: CloseCircleFilledIcon
    }),
        CloseCircleFilledIcon$1 = _useGlobalIcon.CloseCircleFilledIcon;

    var renderTNodeJSX = useTNodeJSX();
    var focused = ref(false);
    var isHover = ref(false);
    var format = computed(function () {
      return calcArrayValue(props2.format);
    });
    var inputProps = computed(function () {
      return calcArrayValue(props2.inputProps);
    });
    var placeholder = computed(function () {
      return calcArrayValue(props2.placeholder);
    });

    var _useVModel = useVModel(value, modelValue, props2.defaultValue, props2.onChange),
        _useVModel2 = _slicedToArray(_useVModel, 2),
        innerValue = _useVModel2[0],
        setInnerValue = _useVModel2[1];

    var isShowClearIcon = computed(function () {
      var _props2$value;

      return (props2.clearable && ((_props2$value = props2.value) === null || _props2$value === void 0 ? void 0 : _props2$value.length) && !disabled.value || props2.showClearIconOnEmpty) && isHover.value;
    });
    var labelContent = renderTNodeJSX("label");
    var prefixIconContent = renderTNodeJSX("prefixIcon");
    var suffixContent = renderTNodeJSX("suffix");
    var suffixIconContent = renderTNodeJSX("suffixIcon");
    var inputRefs = {
      firstInputRef: ref(),
      secondInputRef: ref()
    };

    function handleClear(context) {
      var _props2$onClear;

      (_props2$onClear = props2.onClear) === null || _props2$onClear === void 0 ? void 0 : _props2$onClear.call(props2, context);
      setInnerValue(["", ""], _objectSpread(_objectSpread({}, context), {}, {
        trigger: "clear",
        position: "all"
      }));
    }

    function handleEnter(rangeValue, context) {
      var _props2$onEnter;

      (_props2$onEnter = props2.onEnter) === null || _props2$onEnter === void 0 ? void 0 : _props2$onEnter.call(props2, rangeValue, context);
    }

    function handleFocus(rangeValue, context) {
      var _props2$onFocus;

      focused.value = true;
      (_props2$onFocus = props2.onFocus) === null || _props2$onFocus === void 0 ? void 0 : _props2$onFocus.call(props2, rangeValue, context);
    }

    function handleBlur(rangeValue, context) {
      var _props2$onBlur;

      focused.value = false;
      (_props2$onBlur = props2.onBlur) === null || _props2$onBlur === void 0 ? void 0 : _props2$onBlur.call(props2, rangeValue, context);
    }

    function handleMouseEnter(e) {
      var _props2$onMouseenter;

      isHover.value = true;
      props2 === null || props2 === void 0 ? void 0 : (_props2$onMouseenter = props2.onMouseenter) === null || _props2$onMouseenter === void 0 ? void 0 : _props2$onMouseenter.call(props2, {
        e: e
      });
    }

    function handleMouseLeave(e) {
      var _props2$onMouseleave;

      isHover.value = false;
      props2 === null || props2 === void 0 ? void 0 : (_props2$onMouseleave = props2.onMouseleave) === null || _props2$onMouseleave === void 0 ? void 0 : _props2$onMouseleave.call(props2, {
        e: e
      });
    }

    expose({
      firstInputElement: inputRefs.firstInputRef.value,
      secondInputElement: inputRefs.secondInputRef.value,
      focus: function focus(options) {
        var _inputRefs$value;

        var _ref2 = options || {},
            _ref2$position = _ref2.position,
            position = _ref2$position === void 0 ? "first" : _ref2$position;

        (_inputRefs$value = inputRefs["".concat(position, "InputRef")].value) === null || _inputRefs$value === void 0 ? void 0 : _inputRefs$value.focus();
      },
      blur: function blur(options) {
        var _inputRefs$value2;

        var _ref3 = options || {},
            _ref3$position = _ref3.position,
            position = _ref3$position === void 0 ? "first" : _ref3$position;

        (_inputRefs$value2 = inputRefs["".concat(position, "InputRef")].value) === null || _inputRefs$value2 === void 0 ? void 0 : _inputRefs$value2.blur();
      },
      select: function select(options) {
        var _inputRefs$value3;

        var _ref4 = options || {},
            _ref4$position = _ref4.position,
            position = _ref4$position === void 0 ? "first" : _ref4$position;

        (_inputRefs$value3 = inputRefs["".concat(position, "InputRef")].value) === null || _inputRefs$value3 === void 0 ? void 0 : _inputRefs$value3.select();
      }
    });
    return function () {
      var _ref5, _innerValue$value, _innerValue$value6;

      return createVNode("div", {
        "class": [COMPONENT_NAME.value, (_ref5 = {}, _defineProperty(_ref5, SIZE.value[props2.size], props2.size !== "medium"), _defineProperty(_ref5, STATUS.value.disabled, disabled.value), _defineProperty(_ref5, STATUS.value.focused, focused.value), _defineProperty(_ref5, "".concat(COMPONENT_NAME.value, "--prefix"), prefixIconContent || labelContent), _defineProperty(_ref5, "".concat(COMPONENT_NAME.value, "--suffix"), suffixContent || suffixIconContent), _ref5)],
        "onMouseenter": handleMouseEnter,
        "onMouseleave": handleMouseLeave
      }, [createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__inner")
      }, [prefixIconContent, labelContent ? createVNode("div", {
        "class": "".concat(classPrefix.value, "-input__prefix")
      }, [labelContent]) : null, createVNode(Input, mergeProps({
        "ref": inputRefs.firstInputRef,
        "class": "".concat(COMPONENT_NAME.value, "__inner-left"),
        "inputClass": _defineProperty({}, "".concat(classPrefix.value, "-is-focused"), props2.activeIndex === 0),
        "placeholder": placeholder.value[0],
        "disabled": disabled.value,
        "readonly": props2.readonly,
        "format": format.value[0],
        "value": (_innerValue$value = innerValue.value) === null || _innerValue$value === void 0 ? void 0 : _innerValue$value[0],
        "onClick": function onClick(_ref7) {
          var _props2$onClick;

          var e = _ref7.e;
          return (_props2$onClick = props2.onClick) === null || _props2$onClick === void 0 ? void 0 : _props2$onClick.call(props2, {
            e: e,
            position: "first"
          });
        },
        "onClear": function onClear() {
          return setInnerValue([], {
            position: "first",
            trigger: "input"
          });
        },
        "onEnter": function onEnter(val, _ref8) {
          var _innerValue$value2;

          var e = _ref8.e;
          return handleEnter([val, (_innerValue$value2 = innerValue.value) === null || _innerValue$value2 === void 0 ? void 0 : _innerValue$value2[1]], {
            e: e,
            position: "first"
          });
        },
        "onFocus": function onFocus(val, _ref9) {
          var _innerValue$value3;

          var e = _ref9.e;
          return handleFocus([val, (_innerValue$value3 = innerValue.value) === null || _innerValue$value3 === void 0 ? void 0 : _innerValue$value3[1]], {
            e: e,
            position: "first"
          });
        },
        "onBlur": function onBlur(val, _ref10) {
          var _innerValue$value4;

          var e = _ref10.e;
          return handleBlur([val, (_innerValue$value4 = innerValue.value) === null || _innerValue$value4 === void 0 ? void 0 : _innerValue$value4[1]], {
            e: e,
            position: "first"
          });
        },
        "onChange": function onChange(val, _ref11) {
          var _innerValue$value5;

          var e = _ref11.e;
          return setInnerValue([val, (_innerValue$value5 = innerValue.value) === null || _innerValue$value5 === void 0 ? void 0 : _innerValue$value5[1]], {
            e: e,
            position: "first",
            trigger: "input"
          });
        }
      }, inputProps.value[0]), null), createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__inner-separator")
      }, [props2.separator]), createVNode(Input, mergeProps({
        "ref": inputRefs.secondInputRef,
        "class": "".concat(COMPONENT_NAME.value, "__inner-right"),
        "inputClass": _defineProperty({}, "".concat(classPrefix.value, "-is-focused"), props2.activeIndex === 1),
        "placeholder": placeholder.value[1],
        "disabled": disabled.value,
        "readonly": props2.readonly,
        "format": format.value[1],
        "value": (_innerValue$value6 = innerValue.value) === null || _innerValue$value6 === void 0 ? void 0 : _innerValue$value6[1],
        "onClick": function onClick(_ref13) {
          var _props2$onClick2;

          var e = _ref13.e;
          return (_props2$onClick2 = props2.onClick) === null || _props2$onClick2 === void 0 ? void 0 : _props2$onClick2.call(props2, {
            e: e,
            position: "second"
          });
        },
        "onClear": function onClear() {
          return setInnerValue([], {
            position: "second",
            trigger: "input"
          });
        },
        "onEnter": function onEnter(val, _ref14) {
          var _innerValue$value7;

          var e = _ref14.e;
          return handleEnter([(_innerValue$value7 = innerValue.value) === null || _innerValue$value7 === void 0 ? void 0 : _innerValue$value7[0], val], {
            e: e,
            position: "second"
          });
        },
        "onFocus": function onFocus(val, _ref15) {
          var _innerValue$value8;

          var e = _ref15.e;
          return handleFocus([(_innerValue$value8 = innerValue.value) === null || _innerValue$value8 === void 0 ? void 0 : _innerValue$value8[0], val], {
            e: e,
            position: "second"
          });
        },
        "onBlur": function onBlur(val, _ref16) {
          var _innerValue$value9;

          var e = _ref16.e;
          return handleBlur([(_innerValue$value9 = innerValue.value) === null || _innerValue$value9 === void 0 ? void 0 : _innerValue$value9[0], val], {
            e: e,
            position: "second"
          });
        },
        "onChange": function onChange(val, _ref17) {
          var _innerValue$value10;

          var e = _ref17.e;
          return setInnerValue([(_innerValue$value10 = innerValue.value) === null || _innerValue$value10 === void 0 ? void 0 : _innerValue$value10[0], val], {
            e: e,
            position: "second",
            trigger: "input"
          });
        }
      }, inputProps.value[1]), null), suffixContent ? createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__suffix")
      }, [suffixContent]) : null, suffixIconContent && createVNode("span", {
        "class": "".concat(COMPONENT_NAME.value, "__suffix ").concat(COMPONENT_NAME.value, "__suffix-icon")
      }, [isShowClearIcon.value ? createVNode(CloseCircleFilledIcon$1, {
        "class": "".concat(COMPONENT_NAME.value, "__suffix-clear"),
        "onClick": handleClear
      }, null) : suffixIconContent])]), props2.tips && createVNode("div", {
        "class": "".concat(COMPONENT_NAME.value, "__tips")
      }, [props2.tips])]);
    };
  }
});

export { _RangeInput as default };
//# sourceMappingURL=range-input.mjs.map
